<div class="modal-header justify-content-between">
  <h4 class="modal-title">Load Planogram State</h4>
  <button class="btn btn-link" (click)="cancel()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>

<div class="modal-body p-3">
  @if (states.length > 0) {
    <p class="text-muted mb-3">Select a saved version to restore the planogram layout:</p>
    <div class="state-list-container overflow-y-auto">
      @for (state of states; track state.guid) {
        <div
          class="state-item p-3 d-flex justify-content-between align-items-center"
          [class.selected]="selectedStateId === state.guid"
          (click)="selectedStateId = state.guid"
        >
          <div class="d-flex align-items-center">
            <input
              class="form-check-input mt-0"
              type="radio"
              name="stateRadio"
              [id]="state.guid"
              [value]="state.guid"
              [(ngModel)]="selectedStateId"
            />
            <div class="ms-3">
              <div class="d-flex align-items-center">
                <label class="form-check-label fw-bold mb-0" [for]="state.guid">
                  {{ state.name || "Untitled State" }}
                </label>
                @if (state.approved) {
                  <span class="badge rounded-pill bg-success ms-2">
                    <i class="bi bi-check-circle-fill me-1"></i>Approved
                  </span>
                }
                @if (state.previousApprovedDate && state.previousApprovedBy) {
                  <span class="badge rounded-pill bg-info text-dark ms-2">
                    <i class="bi bi-clock-history me-1"></i>Previously Approved
                  </span>
                }
              </div>
              <div class="save-date mt-1 text-muted small">
                <i class="bi bi-floppy me-1"></i>
                Saved on: {{ state.dateCreated | date:'medium' }}
              </div>
              @if (state.salesPeriodStart && state.salesPeriodEnd) {
                <div class="sales-period mt-1 text-muted small">
                  <i class="bi bi-calendar-range me-1"></i>
                  Sales Period: {{ state.salesPeriodStart | date:'MM/yyyy' }}
                  &ndash; {{ state.salesPeriodEnd | date:'MM/yyyy' }}
                </div>
              }
              @if (state.previousApprovedDate) {
                <div class="approved-date mt-1 text-success small">
                  <i class="bi bi-clock-history me-1"></i>
                  Previously Approved: {{ state.previousApprovedDate | date:'medium' }}
                  @if (state.previousApprovedBy) {
                    by {{ state.previousApprovedBy }}
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
    </div>
  } @else if (isLoading) {
    <div class="text-center p-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2">Loading states...</p>
    </div>
  } @else {
    <div class="alert alert-info">
      No states have been saved yet for this planogram.
    </div>
  }
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-secondary me-2"
    (click)="cancel()"
  >
    Cancel
  </button>
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="selectedStateId === null"
    (click)="confirm()"
  >
    Load
  </button>
</div>
